import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/logo2.png'


const _hoisted_1 = {
  key: 0,
  class: "min-h-full"
}
const _hoisted_2 = { class: "border-b border-gray-200 bg-white" }
const _hoisted_3 = { class: "mx-auto flex h-14 max-w-screen-xl items-center justify-between px-4" }
const _hoisted_4 = { class: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-4 mb-4" }
const _hoisted_5 = { class: "mx-auto" }

import {
  ref,
  watch,
  computed,
  onBeforeMount,
  onMounted,
} from 'vue';
import { useRouter } from 'vue-router';
import usePluginStore from '@/store/plugin/plugin';
import Plugin from '@/models/plugin/plugin';
import TopUserMenu from '@/components/tailwind/layout/shared/TopUserMenu.vue';
import PluginConnectionAlert from '@/components/tailwind/plugin/PluginConnectionAlert.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PluginDashboardLayout',
  setup(__props) {

const router = useRouter();
const { pluginsDoGetMy } = usePluginStore();

/*
  Data
*/
const dataLoaded = ref(false);
const plugin = ref({} as Plugin);
const newPlugins = ref([] as Plugin[]);
// True when the seller has more than one IG/FB plugin — child views use it
// to decide whether to show the "← Painel" back button (a 1-plugin seller
// would just bounce right back here via the auto-redirect).
const hasMultiplePlugins = ref(false);

/*
  Computed
*/
const pluginId = computed(() => router.currentRoute.value.params.pluginId);
const pluginType = computed(() => router.currentRoute.value.params.pluginType);

/*
  Methods
*/
const redirectDashboard = ((error: string) => router.push({
  name: 'DashboardPage',
  query: {
    message: 'Não foi possível carregar a página. Tente novamente em instantes.',
    detail: error,
    type: 'error',
  },
}));

const loadPlugins = () => pluginsDoGetMy(`${pluginId.value}`, undefined, `${pluginType.value}`)
  .then((response) => {
    if (response !== undefined) {
      const plugins = pluginType.value === 'facebook'
        ? response.facebookPlugins
        : response.instagramPlugins;
      if (plugins.length > 0) {
        plugin.value = new Plugin(plugins[0]);
      }
    }
  }).catch((error) => {
    // eslint-disable-next-line no-console
    console.error('error', error);
    redirectDashboard(error.toString());
  });

// Second unfiltered call — counts every IG/FB plugin the user has so the
// child view can hide navigation that would just bounce them back here.
// Small extra call; runs in parallel with `loadPlugins`.
const loadPluginCount = () => pluginsDoGetMy()
  .then((response) => {
    if (response === undefined) return;
    const igCount = response.instagramPlugins?.length || 0;
    const fbCount = response.facebookPlugins?.length || 0;
    hasMultiplePlugins.value = igCount + fbCount > 1;
  })
  .catch(() => {
    // Non-critical — default to false (single-plugin) if count fails. Worst
    // case the back button is hidden when it could have been shown; the user
    // still has TopUserMenu + logo to navigate.
  });

const load = async () => {
  await Promise.all([loadPlugins(), loadPluginCount()]);
  dataLoaded.value = true;
};

/*
  Hooks
*/
onBeforeMount(async () => {
  await load();
});
onMounted(() => {
  setTimeout(() => {
    dataLoaded.value = true;
  }, 500);
});
watch(newPlugins, () => {
  load();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RouterView = _resolveComponent("RouterView")!

  return (dataLoaded.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: { name: 'DashboardPage' },
              class: "inline-flex items-center"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("img", {
                  class: "h-8 w-auto",
                  src: _imports_0,
                  alt: "LiveLink"
                }, null, -1)
              ])),
              _: 1
            }),
            _createVNode(TopUserMenu)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(PluginConnectionAlert, {
            plugin: plugin.value,
            "show-modal": true
          }, null, 8, ["plugin"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_RouterView, {
            plugin: plugin.value,
            "has-multiple-plugins": hasMultiplePlugins.value
          }, null, 8, ["plugin", "has-multiple-plugins"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})